import { render, staticRenderFns } from "./socialsignin.vue?vue&type=template&id=d4381162&scoped=true&"
import script from "./socialsignin.vue?vue&type=script&lang=js&"
export * from "./socialsignin.vue?vue&type=script&lang=js&"
import style0 from "./socialsignin.vue?vue&type=style&index=0&id=d4381162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4381162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4381162')) {
      api.createRecord('d4381162', component.options)
    } else {
      api.reload('d4381162', component.options)
    }
    module.hot.accept("./socialsignin.vue?vue&type=template&id=d4381162&scoped=true&", function () {
      api.rerender('d4381162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/socialsignin.vue"
export default component.exports